import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Button, Row, Col } from 'reactstrap'

import Option from './Option'

const BasicFilters = ({ getUsers, setBasicFilters, filters: filtersSource, previousBasicFilters }) => {
  // get previously chosen filters
  const filtersChosen = { ...previousBasicFilters }
  let defaultValues = {}
  const filters = {
    campaigns: filtersSource['campaigns'],
    states: filtersSource['states'],
    categories: filtersSource['categories'],
    channels: filtersSource['channels'],
    createdAt: filtersSource['createdAt'],
    updatedAt: filtersSource['updatedAt'],
    brands: filtersSource['brands'],
    delegations: filtersSource['delegations']
  }

  if (Object.keys(filtersChosen).length) {
    Object.entries(filters).forEach(([key, data]) => {
      defaultValues[key] = []

      if (filtersChosen[key]) {
        if (['createdAt', 'updatedAt'].includes(key)) {
          defaultValues[key] = [].concat(filtersChosen[key])
        } else {
          defaultValues[key] = [
            ...new Set(
              filtersChosen[key].reduce((preV, next) => {
                if (next.value) {
                  preV.push(next)
                } else {
                  preV.push(data.find((el) => el.value === next))
                }
                return preV
              }, [])
            ),
          ]
        }
      }
    })
  }

  return (
    <>
      <br></br>
      <span className='filters-text'>{I18n.t('campaign_select_recipients_message')}</span>
      <br></br>
      <br></br>
      <Row form className={'animated fadeIn'}>
        {Object.keys(filters).length > 0 && (
          <>
            {Object.keys(filters).map((key, index) => {
              return <Option key={index} label={key} onSelected={setBasicFilters} data={filters[key]} defaultValues={defaultValues[key]} />
            })}
            <Col md={1}>
              <Button color='primary' onClick={getUsers} className='new-button primary'>
                {I18n.t('dashboard_apply')}
              </Button>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

export default BasicFilters
